// src/state/slice/saveProgressSlice.js
import {createSlice} from '@reduxjs/toolkit';

const DynamicFormUtilSlice = createSlice({
  name: 'DynamicFormUtil',
  initialState: {
    activeAccordion: '',
    isCoApplicantSelected: false,
    selectedCoApplicantID: '',
    byPassRoleId: '',
    selectedTab: 'Applicant',
  },
  reducers: {
    setActiveAccordion: (state, action) => {
      state.activeAccordion = action.payload;
    },
    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload;
    },
    setIsCoApplicantSelected: (state, action) => {
      state.isCoApplicantSelected = action.payload;
    },
    setSelectedCoApplicantID: (state, action) => {
      state.selectedCoApplicantID = action.payload;
    },
    resetAccordionState: state => {
      state.activeAccordion = '';
    },
    resetCoApplicantSelected: state => {
      state.isCoApplicantSelected = false;
      state.selectedCoApplicantID = '';
    },
    setBypassRoleId: (state, action) => {
      state.byPassRoleId = action.payload;
    },
  },
});

export const {
  setActiveAccordion,
  setIsCoApplicantSelected,
  resetAccordionState,
  setSelectedCoApplicantID,
  resetCoApplicantSelected,
  setBypassRoleId,
  setSelectedTab,
} = DynamicFormUtilSlice.actions;

export default DynamicFormUtilSlice.reducer;
